import { ReactElement, Suspense } from 'react';
import { Spin } from 'antd';
import { ContentBlock } from '../../../components/layout/ContentBlock';
import type { Honbu } from '../types';
import Title from './Title';
import AdvertisementSections from './AdvertisementSections';
import GStaffUpload from './GStaffUpload';
import { ContentCard, SectionGroup } from './styles';

interface Props {
  honbu: Honbu;
}

const Content = ({ honbu }: Props): ReactElement => {
  return (
    <ContentBlock>
      <ContentCard>
        <Title honbu={honbu} />
        <SectionGroup>
          <Suspense fallback={<Spin />}>
            <AdvertisementSections honbu={honbu} />
          </Suspense>
          {honbu === '2honbu' && <GStaffUpload />}
        </SectionGroup>
      </ContentCard>
    </ContentBlock>
  );
};

export default Content;
